<gc-modal
  [headerTitle]="
    (state === 'completed'
      ? 'installationReportV2.completeConfirmation.completedTitle'
      : 'installationReportV2.completeConfirmation.title'
    ) | translate
  "
  [showCloseIcon]="true"
  [closeOnOutsideClick]="false"
  [width]="'regular'"
  [primaryButtonText]="
    (state === 'completed'
      ? 'installationReportV2.completeConfirmation.closeWindow'
      : 'installationReportV2.completeConfirmation.confirm'
    ) | translate
  "
  [secondaryButtonText]="
    state === 'completed'
      ? undefined
      : ('installationReportV2.completeConfirmation.cancel' | translate)
  "
  [primaryButtonIsDisabled]="state === 'accept' && (!checked || isLoading)"
  [primaryButtonIsLoading]="state === 'accept' && isLoading"
  [secondaryButtonIsDisabled]="isLoading"
  (closeModal)="onDismiss()"
  (primaryButtonClicked)="onPrimaryButtonClick()"
  (secondaryButtonClicked)="onDismiss()"
>
  <div class="complete-report-confirmation-content">
    @if (state === 'accept') {
      <gc-text [variant]="'minorHeading'" [textColor]="'primary'">
        {{
          'installationReportV2.completeConfirmation.whatHappens' | translate
        }}
      </gc-text>
      <ul class="complete-report-confirmation-list">
        <li>
          <gc-text [variant]="'paragraph'">
            {{
              'installationReportV2.completeConfirmation.bulletInvoice'
                | translate
            }}
          </gc-text>
        </li>
        <li>
          <gc-text [variant]="'paragraph'">
            {{
              'installationReportV2.completeConfirmation.bulletLocked'
                | translate
            }}
          </gc-text>
        </li>
      </ul>
      <gc-checkbox
        [ariaLabel]="
          'installationReportV2.completeConfirmation.checkboxLabel' | translate
        "
        [checked]="checked"
        [label]="
          'installationReportV2.completeConfirmation.checkboxLabel' | translate
        "
        (changed)="toggleCheckbox()"
      />
    } @else {
      <gc-text [variant]="'paragraph'">
        {{
          'installationReportV2.completeConfirmation.completedBody' | translate
        }}
      </gc-text>
    }
  </div>
  <app-feedback-alert />
  <app-detailed-error-feedback-alert />
</gc-modal>
